(function() {
    function getApi() {
      return window.vehicleSearchApi || window.vehicleApi;
    }
  
    function shopId() {
      return window.currentShopId?.toString();
    }
  
    function initVehicleSearchBar(root) {
      const sectionId = root.dataset.sectionId;
      if (!sectionId || root.dataset.initialized === 'true') return;
  
      const api = getApi();
      if (!api) return;
  
      root.dataset.initialized = 'true';
  
      const displayMode = root.querySelector(`#vehicle-display-mode-${sectionId}`);
      const searchMode = root.querySelector(`#search-mode-${sectionId}`);
      const makeSelect = root.querySelector(`#manual-make-${sectionId}`);
      const modelSelect = root.querySelector(`#manual-model-${sectionId}`);
      const trimSelect = root.querySelector(`#manual-trim-${sectionId}`);
      const cabTypeSelect = root.querySelector(`#manual-cabtype-${sectionId}`);
      const transmissionSelect = root.querySelector(`#manual-transmission-${sectionId}`);
      const yearSelect = root.querySelector(`#manual-year-${sectionId}`);
      const modelField = root.querySelector(`#manual-model-field-${sectionId}`);
      const trimField = root.querySelector(`#manual-trim-field-${sectionId}`);
      const cabTypeField = root.querySelector(`#manual-cabtype-field-${sectionId}`);
      const transmissionField = root.querySelector(`#manual-transmission-field-${sectionId}`);
      const yearField = root.querySelector(`#manual-year-field-${sectionId}`);
      const submitBtn = root.querySelector(`#vehicle-search-submit-${sectionId}`);
      const manualError = root.querySelector(`#manual-error-${sectionId}`);
      const regInput = root.querySelector(`#reg-input-${sectionId}`);
      const regBtn = root.querySelector(`#search-btn-${sectionId}`);
      const regError = root.querySelector(`#reg-error-${sectionId}`);
      const infoDisplay = root.querySelector(`#vehicle-info-display-${sectionId}`);
      const viewPartsBtn = root.querySelector(`#vehicle-view-parts-${sectionId}`);
      const changeBtn = root.querySelector(`#vehicle-change-${sectionId}`);
      const searchButtonText = root.dataset.searchButtonText || 'GO';
  
      function setManualError(message) {
        if (manualError) manualError.textContent = message || '';
      }
  
      function setRegError(message) {
        if (regError) regError.textContent = message || '';
      }
  
      function hideField(field) {
        if (!field) return;
        field.hidden = true;
        const select = field.querySelector('select');
        if (select) {
          select.value = '';
          select.disabled = true;
        }
      }
  
      function showField(field, select, placeholder, options) {
        if (!field || !select) return;
        select.innerHTML = `<option value="">${placeholder}</option>` +
          options.map((value) => `<option value="${value}">${value}</option>`).join('');
        select.disabled = false;
        field.hidden = false;
      }
  
      function resetSelect(select, placeholder) {
        if (!select) return;
        select.innerHTML = `<option value="">${placeholder}</option>`;
        select.value = '';
        select.disabled = true;
      }
  
      function resetConditionalFields(keepModel) {
        if (!keepModel) {
          hideField(modelField);
          resetSelect(modelSelect, root.dataset.modelLabel || 'Model');
        }
        hideField(trimField);
        hideField(cabTypeField);
        hideField(transmissionField);
        hideField(yearField);
        resetSelect(trimSelect, root.dataset.generationLabel || 'Generation');
        resetSelect(cabTypeSelect, 'Body Style');
        resetSelect(transmissionSelect, 'Transmission');
        resetSelect(yearSelect, root.dataset.versionLabel || 'Version');
        if (submitBtn) {
          submitBtn.disabled = true;
        }
      }
  
      function toggleModes(showDisplay) {
        if (displayMode) {
          displayMode.classList.toggle('active', showDisplay);
          displayMode.style.display = showDisplay ? 'block' : 'none';
        }
        if (searchMode) {
          searchMode.classList.toggle('hidden', showDisplay);
          searchMode.style.display = showDisplay ? 'none' : 'block';
        }
      }
  
      function showYearField(fitments) {
        const years = new Set();
        fitments.forEach((fitment) => {
          if (fitment.yearFrom && fitment.yearTo) {
            for (let year = parseInt(fitment.yearFrom, 10); year <= parseInt(fitment.yearTo, 10); year += 1) {
              years.add(year);
            }
          }
        });
  
        const sortedYears = [...years].sort((a, b) => b - a);
        if (!sortedYears.length || !yearSelect || !yearField) return false;
  
        showField(yearField, yearSelect, root.dataset.versionLabel || 'Version', sortedYears);
        if (submitBtn) submitBtn.disabled = true;
        return true;
      }
  
      function populateMakeSelect(makeSelect, makes, placeholder) {
        if (!makeSelect || !makes.length) return;
        makeSelect.innerHTML = `<option value="">${placeholder}</option>` +
          makes.map((make) => `<option value="${make}">${make}</option>`).join('');
        makeSelect.disabled = false;
      }
  
      async function loadMakes() {
        if (!makeSelect) return;
        if (makeSelect.dataset.makesPreloaded === 'true' || makeSelect.options.length > 1) return;
  
        const placeholder = root.dataset.makeLabel || 'Make';
        const cached = window.vehicleSearchMakesCache;
        if (cached?.length) {
          populateMakeSelect(makeSelect, cached, placeholder);
          return;
        }
  
        const makes = await (window.fetchVehicleMakes ? window.fetchVehicleMakes(api) : Promise.resolve([]));
        if (makes.length) {
          populateMakeSelect(makeSelect, makes, placeholder);
        }
      }
  
      async function performManualSearch() {
        const make = makeSelect?.value;
        const model = modelSelect?.value;
        const year = yearSelect?.value;
  
        if (!make || !model || !year) {
          setManualError('Please complete all fields');
          return;
        }
  
        setManualError('Searching...');
        if (submitBtn) submitBtn.disabled = true;
  
        try {
          const filter = {
            AND: [
              { shopId: { equals: shopId() } },
              { make: { equals: make } },
              { model: { equals: model } }
            ]
          };
  
          if (trimSelect?.value) filter.AND.push({ trim: { equals: trimSelect.value } });
          if (cabTypeSelect?.value) filter.AND.push({ cabType: { equals: cabTypeSelect.value } });
          if (transmissionSelect?.value) filter.AND.push({ transmission: { equals: transmissionSelect.value } });
  
          const response = await api.ProductVehicleFitment.findMany({
            first: 250,
            filter,
            select: {
              yearFrom: true,
              yearTo: true,
              tag: true,
              trim: true,
              collections: true,
              customTags: true,
              make: true,
              model: true,
              cabType: true,
              transmission: true
            }
          });
  
          const matchingFitment = response.find((fitment) =>
            parseInt(year, 10) >= parseInt(fitment.yearFrom, 10) &&
            parseInt(year, 10) <= parseInt(fitment.yearTo, 10)
          );
  
          if (!matchingFitment) throw new Error('No products found for this vehicle');
  
          saveAndRedirect({
            make,
            model,
            year,
            trim: trimSelect?.value || null,
            cabType: cabTypeSelect?.value || null,
            transmission: transmissionSelect?.value || null,
            fuelType: null
          }, matchingFitment);
        } catch (error) {
          setManualError(error.message || 'Search failed');
          if (submitBtn) submitBtn.disabled = false;
        }
      }
  
      function saveAndRedirect(vehicleToSave, matchingFitment) {
        const fitmentToStore = {
          ...matchingFitment,
          make: matchingFitment.make || vehicleToSave.make,
          model: matchingFitment.model || vehicleToSave.model,
          trim: matchingFitment.trim || vehicleToSave.trim || null
        };
  
        localStorage.setItem('selectedVehicle', JSON.stringify(vehicleToSave));
        localStorage.setItem('selectedFitment', JSON.stringify(fitmentToStore));
  
        document.dispatchEvent(new CustomEvent('sc-vehicle-search:save-to-garage', {
          detail: {
            ...vehicleToSave,
            collectionUrl: window.determineCollectionUrl(fitmentToStore)
          },
          bubbles: true
        }));
  
        window.location.href = window.determineCollectionUrl(fitmentToStore);
      }
  
      function renderSavedVehicle() {
        try {
          const savedVehicle = JSON.parse(localStorage.getItem('selectedVehicle') || 'null');
          if (!savedVehicle?.make) {
            toggleModes(false);
            return;
          }
  
          if (infoDisplay) {
            const modelVariant = `${savedVehicle.model || ''}${savedVehicle.trim ? ` ${savedVehicle.trim}` : ''}`.trim();
            const registration = savedVehicle.registration || savedVehicle.vrm || '';
            infoDisplay.innerHTML = `
              <div class="vehicle-name-row">
                ${savedVehicle.year ? `<span class="vehicle-year">${savedVehicle.year}</span>` : ''}
                <strong>${savedVehicle.make} ${modelVariant}</strong>
                ${registration ? `<span class="vehicle-reg">${registration}</span>` : ''}
              </div>
            `;
          }
          toggleModes(true);
        } catch (error) {
          toggleModes(false);
        }
      }
  
      function resetManualSearch() {
        if (makeSelect) makeSelect.value = '';
        resetConditionalFields(false);
        setManualError('');
        loadMakes();
      }
  
      if (regBtn && regInput) {
        regBtn.addEventListener('click', async () => {
          const reg = regInput.value.trim();
          if (!reg) {
            setRegError('Please enter a registration');
            return;
          }
  
          regBtn.disabled = true;
          regBtn.textContent = 'Searching...';
          setRegError('');
  
          try {
            if (!window.lookupVehicleByRegistration) {
              throw new Error('Vehicle lookup is not available. Please refresh the page.');
            }
  
            const data = await window.lookupVehicleByRegistration(reg, regBtn);
            const vehicleData = window.processVehicleData(data);
  
            if (!vehicleData.make || !vehicleData.model) {
              throw new Error('Invalid vehicle data');
            }
  
            const fitmentResults = await api.ProductVehicleFitment.findMany({
              first: 250,
              filter: {
                AND: [
                  { shopId: { equals: shopId() } },
                  { lowercaseMake: { equals: vehicleData.make.toLowerCase() } },
                  { lowercaseModel: { equals: vehicleData.model.toLowerCase() } }
                ]
              },
              select: {
                yearFrom: true,
                yearTo: true,
                tag: true,
                trim: true,
                cabType: true,
                transmission: true,
                collections: true,
                customTags: true,
                make: true,
                model: true
              }
            });
  
            const fitmentsArray = Array.isArray(fitmentResults) ? fitmentResults : (fitmentResults?.data || []);
            const matchingFitment = fitmentsArray.find((fitment) => window.matchFitment(vehicleData, fitment));
  
            if (!matchingFitment) throw new Error('No products found for this vehicle');
  
            saveAndRedirect({
              ...vehicleData,
              registration: reg.toUpperCase()
            }, matchingFitment);
          } catch (error) {
            setRegError(error.message || 'Search failed');
          } finally {
            regBtn.disabled = false;
            regBtn.textContent = searchButtonText;
          }
        });
  
        regInput.addEventListener('keypress', (event) => {
          if (event.key === 'Enter') regBtn.click();
        });
      }
  
      makeSelect?.addEventListener('change', async () => {
        resetConditionalFields(false);
        if (!makeSelect.value) return;
  
        const response = await api.ProductVehicleFitment.findMany({
          first: 250,
          filter: {
            AND: [
              { shopId: { equals: shopId() } },
              { make: { equals: makeSelect.value } }
            ]
          },
          select: { model: true }
        });
  
        const models = [...new Set(response.map((item) => item.model))].filter(Boolean).sort();
        showField(modelField, modelSelect, root.dataset.modelLabel || 'Model', models);
        setManualError('');
      });
  
      modelSelect?.addEventListener('change', async () => {
        resetConditionalFields(true);
        if (!makeSelect?.value || !modelSelect.value) return;
  
        const response = await api.ProductVehicleFitment.findMany({
          first: 250,
          filter: {
            AND: [
              { shopId: { equals: shopId() } },
              { make: { equals: makeSelect.value } },
              { model: { equals: modelSelect.value } }
            ]
          },
          select: { trim: true, cabType: true, transmission: true, yearFrom: true, yearTo: true }
        });
  
        const trims = [...new Set(response.map((item) => item.trim))].filter(Boolean).sort();
        const cabTypes = [...new Set(response.map((item) => item.cabType))].filter(Boolean).sort();
        const transmissions = [...new Set(response.map((item) => item.transmission))].filter(Boolean).sort();
  
        if (trims.length === 0 && cabTypes.length === 0 && transmissions.length === 0) {
          showYearField(response);
          return;
        }
  
        if (trims.length > 0) {
          showField(trimField, trimSelect, root.dataset.generationLabel || 'Generation', trims);
        } else if (cabTypes.length > 0) {
          showField(cabTypeField, cabTypeSelect, 'Body Style', cabTypes);
        } else if (transmissions.length > 0) {
          showField(transmissionField, transmissionSelect, 'Transmission', transmissions);
        }
      });
  
      trimSelect?.addEventListener('change', async () => {
        hideField(cabTypeField);
        hideField(transmissionField);
        hideField(yearField);
        if (submitBtn) submitBtn.disabled = true;
        if (!trimSelect.value) return;
  
        const response = await api.ProductVehicleFitment.findMany({
          first: 250,
          filter: {
            AND: [
              { shopId: { equals: shopId() } },
              { make: { equals: makeSelect.value } },
              { model: { equals: modelSelect.value } },
              { trim: { equals: trimSelect.value } }
            ]
          },
          select: { cabType: true, transmission: true, yearFrom: true, yearTo: true }
        });
  
        const cabTypes = [...new Set(response.map((item) => item.cabType))].filter(Boolean).sort();
        const transmissions = [...new Set(response.map((item) => item.transmission))].filter(Boolean).sort();
  
        if (cabTypes.length === 0 && transmissions.length === 0) {
          showYearField(response);
          return;
        }
  
        if (cabTypes.length > 0) {
          showField(cabTypeField, cabTypeSelect, 'Body Style', cabTypes);
        } else if (transmissions.length > 0) {
          showField(transmissionField, transmissionSelect, 'Transmission', transmissions);
        }
      });
  
      cabTypeSelect?.addEventListener('change', async () => {
        hideField(transmissionField);
        hideField(yearField);
        if (submitBtn) submitBtn.disabled = true;
        if (!cabTypeSelect.value) return;
  
        const filter = {
          AND: [
            { shopId: { equals: shopId() } },
            { make: { equals: makeSelect.value } },
            { model: { equals: modelSelect.value } },
            { cabType: { equals: cabTypeSelect.value } }
          ]
        };
        if (trimSelect?.value) filter.AND.push({ trim: { equals: trimSelect.value } });
  
        const response = await api.ProductVehicleFitment.findMany({
          first: 250,
          filter,
          select: { transmission: true, yearFrom: true, yearTo: true }
        });
  
        const transmissions = [...new Set(response.map((item) => item.transmission))].filter(Boolean).sort();
        if (transmissions.length === 0) {
          showYearField(response);
          return;
        }
  
        showField(transmissionField, transmissionSelect, 'Transmission', transmissions);
      });
  
      transmissionSelect?.addEventListener('change', async () => {
        hideField(yearField);
        if (submitBtn) submitBtn.disabled = true;
        if (!transmissionSelect.value) return;
  
        const filter = {
          AND: [
            { shopId: { equals: shopId() } },
            { make: { equals: makeSelect.value } },
            { model: { equals: modelSelect.value } },
            { transmission: { equals: transmissionSelect.value } }
          ]
        };
        if (trimSelect?.value) filter.AND.push({ trim: { equals: trimSelect.value } });
        if (cabTypeSelect?.value) filter.AND.push({ cabType: { equals: cabTypeSelect.value } });
  
        const response = await api.ProductVehicleFitment.findMany({
          first: 250,
          filter,
          select: { yearFrom: true, yearTo: true }
        });
  
        showYearField(response);
      });
  
      yearSelect?.addEventListener('change', () => {
        if (submitBtn) submitBtn.disabled = !yearSelect.value;
        setManualError('');
        if (yearSelect.value) performManualSearch();
      });
  
      submitBtn?.addEventListener('click', performManualSearch);
  
      viewPartsBtn?.addEventListener('click', () => {
        try {
          const fitment = JSON.parse(localStorage.getItem('selectedFitment') || 'null');
          if (fitment && window.determineCollectionUrl) {
            window.location.href = window.determineCollectionUrl(fitment);
          } else {
            window.location.href = '/collections/all?sort_by=best-selling';
          }
        } catch (error) {
          window.location.href = '/collections/all?sort_by=best-selling';
        }
      });
  
      changeBtn?.addEventListener('click', () => {
        localStorage.removeItem('selectedVehicle');
        localStorage.removeItem('selectedFitment');
        if (regInput) regInput.value = '';
        setRegError('');
        resetManualSearch();
        toggleModes(false);
      });
  
      document.addEventListener('sc-vehicle-search:save-to-garage', renderSavedVehicle);
      window.addEventListener('storage', (event) => {
        if (event.key === 'selectedVehicle') renderSavedVehicle();
      });
  
      renderSavedVehicle();
      loadMakes();
  
      document.addEventListener('vehicle-search-makes-ready', (event) => {
        if (makeSelect?.dataset.makesPreloaded === 'true' || makeSelect?.options.length > 1) return;
        const makes = event.detail?.makes || window.vehicleSearchMakesCache;
        if (makes?.length) {
          populateMakeSelect(makeSelect, makes, root.dataset.makeLabel || 'Make');
        }
      });
    }
  
    function initAll() {
      document.querySelectorAll('[data-vehicle-search-bar]').forEach(initVehicleSearchBar);
    }
  
    document.addEventListener('vehicle-search-api-ready', initAll);
    if (getApi()) initAll();
  })();
  